export const NAMES = {
  outOfStock: 'out-of-stock-message',
  logo: 'restaurant-logo',
  promotion: 'promotion',
  mainCard: 'menu-category-card'
}